<template>
  <div class="m-grid m-grid--hor m-grid--root m-page">

    <page-header></page-header>

    <transition name="fade" mode="out-in">
      <router-view></router-view>
    </transition>

    <page-footer></page-footer>

  </div>
</template>

<script>
  import Header from './Header'
  import Footer from './Footer'

  export default {
    components: {
      'page-header': Header,
      'page-footer': Footer,
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Client/Main.vue